import request, { Methods, withToken, RequestType } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_FILES_CLIENT_RESET = 'POST_FILES_CLIENT_RESET';
export const POST_FILES_CLIENT_LOADING = 'POST_FILES_CLIENT_LOADING';
export const POST_FILES_CLIENT_SUCCESS = 'POST_FILES_CLIENT_SUCCESS';
export const POST_FILES_CLIENT_REJECT = 'POST_FILES_CLIENT_REJECT';

//* ACTIONS ------------------------------------------------
export const postFilesClientReset = () => ({ type: POST_FILES_CLIENT_RESET });
export const postFilesClientLoading = () => ({ type: POST_FILES_CLIENT_LOADING });
export const postFilesClientSuccess = (payload) => ({ type: POST_FILES_CLIENT_SUCCESS, payload });
export const postFilesClientReject = (payload) => ({ type: POST_FILES_CLIENT_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const postFilesClientRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.POST,
        headers: RequestType.Multipart,
        data,
    }, getState);

    return request(`/Clients/web/AddClientUploadFile`, options);
};
